import type { Ref } from 'react'
import { motion, useIsPresent, useReducedMotion, type HTMLMotionProps } from 'framer-motion'
import { Icons } from '../icons/registry'
import { cn } from '../lib/cn'
import { DURATION, EASE_IN, EASE_OUT } from '../tokens/motion'

/** Render under AnimatePresence so all dismissal paths use the same exit. */
export function DropdownPanel({
  above = false,
  style,
  role,
  'aria-label': label,
  'data-wf-popover': popover,
  ...props
}: HTMLMotionProps<'div'> & { ref?: Ref<HTMLDivElement>; above?: boolean; 'data-wf-popover'?: boolean }) {
  const present = useIsPresent()
  const reduce = useReducedMotion()
  const hidden = { opacity: 0, y: reduce ? 0 : above ? 4 : -4, scale: reduce ? 1 : 0.98 }
  return (
    <motion.div
      {...props}
      role={present ? role : undefined}
      aria-label={present ? label : undefined}
      aria-hidden={!present || undefined}
      inert={!present}
      data-wf-popover={present ? popover : undefined}
      initial={hidden}
      animate={{ opacity: 1, y: 0, scale: 1, transition: { duration: DURATION.base, ease: EASE_OUT } }}
      exit={{ ...hidden, transition: { duration: DURATION.fast, ease: EASE_IN } }}
      style={{ transformOrigin: above ? 'bottom' : 'top', ...style, pointerEvents: present ? style?.pointerEvents : 'none' }}
    />
  )
}

export function DropdownChevron({ open, size }: { open: boolean; size?: 'xs' | 'sm' }) {
  return (
    <span aria-hidden className={cn('inline-flex shrink-0 origin-center text-muted-foreground transition-transform duration-fast motion-reduce:transition-none', open && 'rotate-180')}>
      <Icons.dropdown size={size} />
    </span>
  )
}
